import { useState } from "react"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Button,
  Input,
  VStack,
  Heading,
  FormControl,
  FormLabel,
  useToast,
} from "@chakra-ui/react"

// TODO: Move this to an environment variable (e.g., process.env.VITE_APP_PASSWORD) my-choices
const CORRECT_PASSWORD = "seciohc"
const AUTH_KEY = "authExpiry"
const AUTH_DURATION_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

const PasswordPage: React.FC = () => {
  const [password, setPassword] = useState("")
  const navigate = useNavigate()
  const toast = useToast()

  const handleLogin = () => {
    if (password === CORRECT_PASSWORD) {
      const expiryTime = new Date().getTime() + AUTH_DURATION_MS
      localStorage.setItem(AUTH_KEY, expiryTime.toString())
      navigate("/") // Redirect to the main app page
    } else {
      toast({
        title: "Incorrect Password",
        description: "Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      })
      setPassword("")
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleLogin()
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      // dvh: see App.tsx; 100vh alone overflows a phone with its toolbar.
      height="100vh"
      sx={{ "@supports (height: 100dvh)": { height: "100dvh" } }}
      bg="gray.100"
      _dark={{ bg: "gray.700" }}
    >
      <VStack
        spacing={4}
        p={8}
        bg="white"
        _dark={{ bg: "gray.800" }}
        borderRadius="md"
        boxShadow="md"
      >
        <Heading size="lg">Enter Password</Heading>
        <FormControl>
          <FormLabel htmlFor="password">Password</FormLabel>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter password"
          />
        </FormControl>
        <Button colorScheme="teal" onClick={handleLogin} width="full">
          Login
        </Button>
      </VStack>
    </Box>
  )
}

export default PasswordPage
